/**
 * Minimal payload describing a failed transport-level backend call.
 *
 * This intentionally excludes full responses because the gate only needs enough
 * context to correlate local logs with the request that observed the outage.
 */
export interface NetworkFailurePayload {
  url?: string;
  method?: string;
  status?: number;
  message?: string;
}

type NetworkFailureListener = (payload: NetworkFailurePayload) => void;

const listeners = new Set<NetworkFailureListener>();

/**
 * Lightweight event hub for backend transport failures.
 *
 * The admin API health gate subscribes to these events so a request that cannot
 * reach the backend can trigger a fresh `/api-health` probe without coupling
 * individual pages to the global overlay.
 */
export const API_HEALTH_EVENTS = {
  onNetworkFailure: (handler: NetworkFailureListener): (() => void) => {
    listeners.add(handler);
    return () => {
      listeners.delete(handler);
    };
  },
  emitNetworkFailure: (payload: NetworkFailurePayload): void => {
    listeners.forEach((listener) => {
      listener(payload);
    });
  },
};
